import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initAnalytics } from './utils/analytics';

// Vang het install-event vroeg op, ook als React nog niet gemount is.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPWAEvent = e as never;
});

// Productie: registratie gebeurt in <UpdateToast /> (vite-plugin-pwa).
// Dev: nooit een service worker; ruim een oude op (die serveerde ooit verouderde /src-modules).
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .then(() => caches.keys())
    .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
    .catch(() => {});
}

// Productie: eenmalig de cache van de oude handgeschreven service worker (gameon-v40 e.d.) opruimen.
if (!import.meta.env.DEV && 'caches' in window) {
  caches
    .keys()
    .then((keys) => Promise.all(keys.filter((k) => k.startsWith('gameon-v')).map((k) => caches.delete(k))))
    .catch(() => {});
}

// Laadt Google Analytics alleen als de bezoeker eerder toestemming gaf.
initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
